/**
 * Donate Now button resolver.
 *
 * Given a story (any object with optional `donation_link` + `category` +
 * `story_status`) and a public-config bundle (from `/api/config/public`),
 * return the effective URL the green Donate button should point to — or
 * `null` if no Donate button should render.
 *
 * Priority:
 *   1. `story_status === 'goal_reached'` or `'worth_telling'` → null
 *      (the calling component should render a celebratory "Goal reached"
 *      ribbon for `goal_reached` instead).
 *   2. Story's own `donation_link` (creator-set) → always wins.
 *   3. `default_donation_url` from backend config, if the story's `category`
 *      is in `fundraising_categories` (charity, animal_rescue, social_impact,
 *      environment).
 *   4. Otherwise → null (no donate button).
 */
export function resolveDonationUrl(story, config) {
  if (!story) return null;
  const status = story.story_status || "active";
  if (status !== "active") return null;
  const own = (story.donation_link || "").trim();
  if (own) return { url: own, source: "own" };
  const cfg = config || {};
  const fallback = (cfg.default_donation_url || "").trim();
  const cats = cfg.fundraising_categories || [];
  if (fallback && story.category && cats.includes(story.category)) {
    return { url: fallback, source: "fallback" };
  }
  return null;
}

/** Returns one of "active" | "goal_reached" | "worth_telling". */
export function getStoryStatus(story) {
  return story?.story_status || "active";
}
